<script lang="ts">
import { computed, defineComponent } from "vue";
import { injectPool } from "@/shared/utils/injection";
import { getProbeType } from "@/shared/utils/probes";
import { getOutByName } from "@/shared/utils/outs";
import ConfirmDirtyExitModal from "@/shared/components/ConfirmDirtyExitModal.vue";

export default defineComponent({
  components: { ConfirmDirtyExitModal },
  ...injectPool,

  provide() {
    return {
      probe: computed(() => this.probe),
      out: computed(() => this.out),
    };
  },

  data() {
    return {
      showConfirm: false,
      next: () => {},
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isPoolDirty) {
      this.showConfirm = true;
      this.next = next;
    } else {
      next();
    }
  },

  computed: {
    probeIdx() {
      return parseInt(this.$route.params.probeIdx as string);
    },
    probe() {
      return this.pool.probes.find((probe) => probe.index === this.probeIdx);
    },
    out() {
      if (this.probe) {
        const outName = getProbeType(this.probe.type).out;
        if (outName) {
          const outIdx = getOutByName(outName).index;
          return this.pool.outs.find((out) => out.index === outIdx);
        }
      }
      return undefined;
    },
  },
});
</script>

<template>
  <confirm-dirty-exit-modal
    :show-confirm="showConfirm"
    @close="showConfirm = false"
    @next="next"
  />
  <router-view />
</template>
